import initialState from "../../../../reducers/initialState";
import { PR } from "./actions";

const PurchaseRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case PR.ADD_ORDERS_MODAL: {
      return {
        ...state,
        AddNewOrderModal: !state.AddNewOrderModal,
        ListofAvailabelPRContract: action.data,
        selectedProductForOrdering: action.product,
      };
    }
    case PR.CLOSE_ADD_ORDERS_MODAL: {
      return {
        ...state,
        AddNewOrderModal: !state.AddNewOrderModal,
        ListofAvailabelPRContract: [],
        selectedProductForOrdering: null,
      };
    }
    case PR.ADD_MATERIALS_MODAL: {
      return {
        ...state,
        AddNewMaterialsModal: !state.AddNewMaterialsModal,
        ListofMaterials: action.data,
      };
    }
    case PR.CLOSE_ADD_MATERIAL_MODAL: {
      return {
        ...state,
        AddNewMaterialsModal: !state.AddNewMaterialsModal,
        ListofMaterials: [],
      };
    }
    case PR.CONFIRM_CLOSE_ADD_MATERIAL_MODAL: {
      return {
        ...state,
        AddNewMaterialsModal: !state.AddNewMaterialsModal,
      };
    }

    case PR.UPDATE_LIST_OF_MATERIALS: {
      return {
        ...state,
        ListofMaterials: action.data,
      };
    }

    case PR.UDATE_MATERIAL_FOR_EACH_ROW: {
      return {
        ...state,
        materialForEachRow: action.data,
      };
    }
    case PR.ADD_EMPTY_ITEMS_TO_MATERIAL_FOR_EACH_ROW: {
      let _materialForEachRow = state.materialForEachRow;
      const obj = {
        items: [],
      };
      _materialForEachRow.push(obj);
      return {
        ...state,
        materialForEachRow: _materialForEachRow,
      };
    }

    case PR.RESET_CREATE_LIST_OF_MRP_STORE: {
      return {
        ...state,
        selectedMaterials: [],
      };
    }

    //--------------
    case PR.UPDATE_WAITING_MRP_LIST_FOR_NEW_PR: {
      return {
        ...state,
        waitingMrpListForNewPR: action.data,
      };
    }
    case PR.UPDATE_WAITING_BADGE_COUNT: {
      return {
        ...state,
        waitingMrpForNewPrBadgeCount: action.badgeCount.waitingForNewPRQuantity,
        waitingMrpForConfirmPrBadgeCount:
          action.badgeCount.waitingForConfirmQuantity,
      };
    }
    case PR.UPDATE_SELECTED_MATERIALS_LIST: {
      return {
        ...state,
        ListofMaterials: action.ListofMaterials,
        selectedMaterials: action.selectedMaterials,
      };
    }
    case PR.ADD_NOTE_MODAL: {
      return {
        ...state,
        NoteModal: !state.NoteModal,
        prNote: "",
      };
    }
    case PR.CLOSE_NOTE_MODAL: {
      return {
        ...state,
        NoteModal: !state.NoteModal,
        prNote: "",
      };
    }
    case PR.REMOVE_NOTE: {
      return {
        ...state,
        prNote: "",
      };
    }
    case PR.CONFIRM_CLOSE_NOTE_MODAL: {
      return {
        ...state,
        NoteModal: !state.NoteModal,
        prNote: action.data,
      };
    }
    case PR.INITIAL_STATE_REGITER_PR_STORE: {
      return {
        ...state,
        selectedMaterials: [],
        prNote: "",
      };
    }
    case PR.UPDATE_WAITING_MRP_LIST_FOR_CONFIRM_PR: {
      return {
        ...state,
        waitingMrpListForConfirmPR: action.data,
      };
    }
    case PR.CONFIRM_REJECT_MODAL: {
      return {
        ...state,
        ConfirmRejectModal: !state.ConfirmRejectModal,
        isConfirm: action.isConfirm,
      };
    }
    case PR.CLOSE_CONFIRM_REJECT_MODAL: {
      return {
        ...state,
        ConfirmRejectModal: !state.ConfirmRejectModal,
      };
    }
    case PR.CONFIRMCLOSE_CONFIRM_REJECT_MODAL: {
      return {
        ...state,
        ConfirmRejectModal: !state.ConfirmRejectModal,
        isConfirm: false,
      };
    }

    case PR.UPDATET_PR_LIST: {
      return {
        ...state,
        prList: action.data,
        defaultPr: action.defaultPr,
      };
    }
    case PR.UPDATE_DEFAULT_PR: {
      return {
        ...state,
        defaultPr: action.data,
      };
    }
    case PR.UPDATE_PR_DETAILS_INFO: {
      return {
        ...state,
        prList: action.newprList,
        defaultPr: action.defaultPr,
        PrDetailsInfo: action.PrDetailsInfo,
      };
    }
    case PR.UPDATE_PR_DETAILS_INFO_BY_DEFAULT: {
      return {
        ...state,
        PrDetailsInfo: action.data,
      };
    }
    case PR.VIEW_DOC_MODAL: {
      return {
        ...state,
        ViewDocsModal: !state.ViewDocsModal,
        viewDocList: action.data,
      };
    }
    case PR.CLOSE_VIEW_DOC_MODAL: {
      return {
        ...state,
        ViewDocsModal: !state.ViewDocsModal,
        viewDocList: [],
      };
    }
    case PR.UPDATE_NOTE: {
      return {
        ...state,
        prNote: action.note,
      };
    }
    default:
      return state;
  }
};

export default PurchaseRequestReducer;
